import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class NewsPanel extends Phaser.GameObjects.Container {

    private onAcceptCallback: (() => unknown) | undefined;

    constructor(scene: Scene, canvas: HTMLCanvasElement, title: string, content: string,
                onAcceptCallback: () => unknown, delayButton: boolean = true, isLongNews:boolean = false) {
        super(scene);
        this.x = canvas.width / 2;
        this.y = canvas.height / 2 - 30;

        this.setDepth(5001);

        let background = SpriteUtils.addSprite(this.scene, 0, 0, Keys.ATLAS_UI, Keys.UI_BLACK).setInteractive();
        SpriteUtils.setDispSize(background, canvas!.width * 2, canvas!.height * 2);
        this.add(background);

        let window = SpriteUtils.addImage(this.scene, 0, 0, this.getWindowKey(), undefined,
            this.getScaleX(), this.getScaleY()).setOrigin(0.5, 0.5);
        this.add(window);

        let titleEl = TextUtils.addTextByFamily(this.scene, title, 0, this.getTitleY(), '#ffffff', 16,
            'normal', this.getContentWidth(), Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        this.add([window, titleEl]);

        this.onAcceptCallback = onAcceptCallback;

        let self = this;
        let contentText = new BBCodeText(scene, - self.getContentWidth() * CU.S / 2, this.getXButtonY() * CU.S + 90 * CU.S, content, {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '14pt',
            align: 'left',
            wrap: {
                mode: 1,
                width: self.getContentWidth()
            }
        }).setScale(CU.S, CU.S);

        let xButton = SpriteUtils.addImage(this.scene, this.getXButtonX(), this.getXButtonY(), Keys.ATLAS_PROFILE, Keys.UI_ART_X).setOrigin(0.5, 0.5);
        this.add(xButton);

        xButton.setInteractive().on('pointerup', function() {
            onAcceptCallback();
        });

        this.add([contentText]);

        this.addCustomButton(scene, 0, isLongNews? this.getOkButtonYForLongVersion() : this.getOkButtonY(), Tr('otlichno').toUpperCase(),
            Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, delayButton, onAcceptCallback);
    }

    protected getWindowKey(): string {
        return Keys.UI_WINDOW_MIDDLE_BIG
    }

    protected getContentWidth(): number {
        return 420;
    }

    protected getXButtonX(): number {
        return 232;
    }

    protected getXButtonY(): number {
        return -310;
    }

    protected getScaleX(): number {
        return 1.05;
    }

    protected getScaleY(): number {
        return 1.08;
    }

    protected getOkButtonY(): number {
        return 190;
    }
    protected getOkButtonYForLongVersion(): number {
        return 300;
    }

    protected getTitleY(): number {
        return -282;
    }

    protected addCustomButton(scene: Scene, x: number, y: number, text: string, buttonBackground: string,
                              buttonAtlas: string | undefined, buttonIcon: string, delayButton: boolean, callback?: () => unknown) {
        let okButton = new SquareButton(this.scene, x, y, 0, buttonBackground,
            buttonAtlas, buttonIcon, text.toLocaleUpperCase(), false);

        this.add(okButton);

        if (delayButton) {
            okButton.setAlpha(0);

            scene.tweens.add({
                targets: okButton,
                alpha: 1,
                delay: 500,
                duration: 1000,

                onComplete: function () {
                    okButton.setCallback(() => {
                        if (callback != null) {
                            callback();
                        }
                    });
                },
            });
        } else {
            okButton.setCallback(() => {
                if (callback != null) {
                    callback();
                }
            });
        }
    }

    public open(): void {
        this.scene.add.existing(this);
    }

    public openAnimated(): void {
        this.open();
        this.setAlpha(0);
        SpriteUtils.scale(this, 0.92);

        this.scene!.tweens.add({
            targets: this,
            alpha: 1,
            scale: 1,
            delay: 0,
            duration: 200
        });
    }

    public close(): void {
        this.setVisible(false);
        this.destroy();
    }
}
